import { Box, Button, List, ListItem, Stack, Typography } from "@mui/material";
import styles from "../../styles/components/messageTypeBox.module.scss";
import React, { useState } from "react";
import assest from "../../json/assest";
import { SubmitHandler, useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import axiosInstance from "../../api/axiosInstance";
import {
  getCurrentUTCDateTime,
  getStyledDateTime,
  styledDateTime,
} from "../../lib/functions/utils.lib";
import useNotistack from "../../hooks/useNotistack";
import { useRef } from "react";
const schema = yup.object().shape({
  message: yup.string().required("Message is required"),
  inquiry_id: yup.number().required(),
});

const PurchaseMessageTypeBox = (props) => {
  const {
    handleSubmit,
    control,
    register,
    setValue,
    reset,
    formState: { errors },
    formState,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      message: "",
      inquiry_id: props.inquiry?.id || 0,
    },
  });
  const { toastError } = useNotistack();
  const fileInputRef = useRef(null);
  const [attachments, setAttachments] = useState([]); // Set the initial state as an empty array of `File` objects

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      setAttachments((curr) => [...curr, file]); // Use spread syntax to create a new array with the new file added
    }
  };

  /* const removeFile = (file_index) => {
    setAttachments((curr) => curr.filter((_, index) => file_index !== index));
  };
 */

  const removeFile = (file_index) => {
    setAttachments((curr) => curr.filter((_, index) => file_index !== index));
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const SubmitForm = async (messageData) => {
    try {
      const formData = new FormData();
      //   formData.append("type", "message");
      formData.append("message", messageData.message);

      // Append each attachment to the FormData
      attachments.forEach((file, index) => {
        formData.append(`attachments[${index}]`, file);
      });

      const { data } = await axiosInstance.post(
        `purchase_request/${props?.inquiry?.id}/create-message`,
        formData
      );
      reset();
      setAttachments([]);
      props?.toggleRepondToInquiry();
      props.refreshMessages();
      console.warn(data);
    } catch (error) {
      console.error(error);
      toastError(error?.response?.data?.message);
    }
  };

  // return <Box className="messageModal">{/* Rest of the code... */}</Box>;
  return (
    <Box className="messageModal">
      <Box
        className={`${styles.purchasedMessageModalHeader} messageModalHeader`}
      >
        <Box className="messageMOdalProfile">
          <Box className="messageMOdalProfileImg">
            <img
              src={assest.messageProfileIcon}
              width={39}
              height={39}
              alt=""
            />
          </Box>
          <h4>
            Me, Myself & I <span>(Admin)</span>
          </h4>
        </Box>
        <p>{getCurrentUTCDateTime()}</p>
      </Box>

      <Box className={`${styles.purchasemessageModalBody} messageModalBody`}>
        <Box className="messageInput">
          <textarea {...register("message")}></textarea>
        </Box>

        <Box
          className={`attachFileinput attachFileinputMessage ${styles.purchasedAttachFileinput}`}
        >
          <input
            type="file"
            ref={fileInputRef}
            id="upload"
            onChange={handleFileChange}
            hidden
          />
          {attachments?.length > 0 ? (
            ""
          ) : (
            <label htmlFor="upload">
              <img src={assest.attachIcon} width={13} height={15} alt="" />{" "}
              Attach a file
            </label>
          )}
        </Box>
        {/* ============================================== */}
        {/* ========== FOR SHOW FILE NAME START ========== */}

        <Stack direction="row" className={styles.filesName}>
          <List className={styles.fileLists}>
            {attachments?.length
              ? attachments.map((item, index) => {
                  return (
                    <ListItem key={index}>
                      <span className={styles.btnStyledFile}>
                        <img
                          src={assest.IconTrash}
                          width={16}
                          height={16}
                          alt="icon"
                          onClick={() => removeFile(index)}
                          style={{ cursor: "pointer" }}
                        />
                        <Typography variant="overline">
                          {item?.name ? item.name : "N/A"}
                        </Typography>
                      </span>

                      {attachments?.length === index + 1 ? (
                        <Button
                          className={styles.addFiles}
                          // onClick={() => removeFile(index)}
                        >
                          <label htmlFor="upload">
                            <img
                              src={assest.IconAddfile}
                              width={23.29}
                              height={23.29}
                              alt=""
                            />
                          </label>
                        </Button>
                      ) : (
                        ""
                      )}
                    </ListItem>
                  );
                })
              : ""}
            {/*  {attachments?.length ? (
              <ListItem>
                <Box className={styles.addFiles}>
                  <input
                    type="file"
                    id="upload"
                    onChange={handleFileChange}
                    hidden
                  />
                  <label htmlFor="upload">
                    <img
                      src={assest.IconAddfile}
                      width={23.29}
                      height={23.29}
                      alt=""
                    />
                  </label>
                </Box>
              </ListItem>
            ) : (
              ""
            )} */}
          </List>
        </Stack>
      </Box>

      <Box
        className={`messageModalFooter ${styles.purchaseMessageModalFooter}`}
      >
        <Button onClick={props?.toggleRepondToInquiry}>Cancel</Button>
        <Button className="active" onClick={handleSubmit(SubmitForm)}>
          Send <span>now</span>
        </Button>
      </Box>
    </Box>
  );
};

export default PurchaseMessageTypeBox;
